import src from "IMAGE";
export default { src, width: 2920, height: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AM7b7OzU3+/P2+Txr+Hp9I/o7vZw7vP5UPX4+zD5+/wTv4EaIERApOEAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 1 }
